// @ts-strict-ignore
import React from "react";
import ErrorBoundary from "../ErrorBoundary";
import type { ErrorBoundaryProps } from "../types";

/**
 * @deprecated this model of composition is no longer in favor. Instead, just compose
 *   your components with ErrorBoundary directly
 */
export function WithErrorBoundary<T>(Component: React.ComponentType<T>, config?: ErrorBoundaryProps) {
  const Wrapper = (props: T): React.ReactElement => {
    return (
      <ErrorBoundary {...config}>
        <Component {...props} />
      </ErrorBoundary>
    );
  };

  return Wrapper;
}
